'use client';
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import VerticalMultiSelection from '../components/vertical_multi_selection';
import { SelectionData } from '../questions';

export const groupBy = (array: any, key:any) => {
  // Return the end result
    return array.reduce((result:any, currentValue:any) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
}; 

const MultiImageCarousalMultiSelection: React.FC<SelectionData> = ({selectedAnswer, setSelectedAnswer, choices, editData, props, shortQuestion}) => {
    let [carousalArr,setCarousalArr] = useState([]) as any;
    const isDataBuilt = useRef(false);
    const choicesGroup = useRef({} as any);
  
    useLayoutEffect(()=>{
      console.log(choices.length);  
      if(isDataBuilt.current) return;
  
      choicesGroup.current = groupBy(choices,(props.isPersonality) ? "choice" : "subtext");
      let componetsArr = [] as any;
      for (let [subtext, groupWiseChoicesArr] of Object.entries(choicesGroup.current  )) {
        componetsArr.push(
          <>        
        <VerticalMultiSelection
        selectedAnswer = {selectedAnswer}  
        setSelectedAnswer={setSelectedAnswer} 
        choices={groupWiseChoicesArr} 
        editData={editData}
        isBudgetFlow={shortQuestion == 'Brand Preferences'}
        label={subtext}
        props={{"imageGridMultiSelection": true,isPersonality: props.isPersonality, "saveMultiCarousalSelection": true, "styleQPref" : props.styleQPref, show_more: props?.template?.show_more }} />
        </>)
      }
      isDataBuilt.current = true;
      setCarousalArr(componetsArr)
      
    },[])
  
  
    if(Object.keys(choicesGroup.current).length <= 0){
      return <>no data</>;
    }
  
   return (<>{carousalArr}</>)
  }

  export default MultiImageCarousalMultiSelection;